module.exports = __webpack_public_path__ + "media/svg-new/logo-login-9132b1bd.svg";